import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import i18n from '../../services/i18n'
import { Headings, Input, Padding } from '../../components'

const deviceMigrationStatusValues = [
    {
        name: i18n.t('devices-migration-status-migrated'),
        value: '1',
    },
    {
        name: i18n.t('devices-migration-status-notmigrated'),
        value: '0',
    },
]

function MigrationStatus({ migrationStatus, setMigrationStatus, t }) {
    return (
        <Padding>
            <Padding bottom>
                <Headings.H2>{t('devices-migration-status')}</Headings.H2>
            </Padding>
            <Input
                type="multiple"
                onChange={({ target: { value } }) => setMigrationStatus(value)}
                value={migrationStatus}
                values={deviceMigrationStatusValues}
            />
        </Padding>
    )
}

MigrationStatus.propTypes = {
    migrationStatus: PropTypes.arrayOf(PropTypes.string),
    setMigrationStatus: PropTypes.func,
    t: PropTypes.func,
}

MigrationStatus.defaultProps = {
    migrationStatus: [],
    setMigrationStatus: () => null,
    t: () => null,
}

export default withTranslation()(MigrationStatus)
